import { useTranslation } from 'react-i18next'

import { ProgressSpinner } from 'primereact/progressspinner'

export const LoadingScreen: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="flex h-24rem flex-column align-items-center align-content-center justify-content-center">
      <ProgressSpinner
        style={{ width: '48px', height: '48px' }}
        strokeWidth="2"
      />
      <span className="mt-3 text-sm">{t('common.labels.loading')}</span>
    </div>
  )
}
